import * as Constants from '../constants';

import React, { useState, useEffect } from 'react';

import Loading from '../components/UI/Loading';
import ScrollContainer from '../components/UI/ScrollContainer';
import UserProfileForm from '../components/profile/UserProfileForm';
import MessageDialog from '../components/UI/MessageDialog';
import AdvertisementPanel from '../components/UI/AdvertisementPanel';

function ProfilePage() {
    const [isLoading, setIsLoading] = useState(true);
    const [updateConfirmationIsShown, setUpdateConfirmationIsShown] = useState(false);


    const updateProfile = async (data) => {
        if (data['password'].trim() === "") data['password'] = undefined;
        if (data['confirmPassword'].trim() === "") data['confirmPassword'] = undefined;

        const id = localStorage.getItem("id");
        console.warn(localStorage)
        const url = `${Constants.PROFILE_UPDATE}?id=${id}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        console.log(response);
        setUpdateConfirmationIsShown(true);
    };

    const closeMessageDialogHandler = () => {
        setUpdateConfirmationIsShown(false);
    };

    useEffect(() => {
        setIsLoading(true);

        setIsLoading(false);
    }, []);

    return <>
        {isLoading && <Loading />}
        {updateConfirmationIsShown && <MessageDialog
            variant="warning"
            onClose={closeMessageDialogHandler}
            header="Atenção!"
            message={"Perfil salvo com sucesso!"}
        />}
        {!isLoading && <>
            <div className="row mainPanel px-2">
                <div className="col col-md-12">
                    <ScrollContainer heightMultiplier={0.7815}>
                        <UserProfileForm edit={true} submitHandler={updateProfile} editPassword={true} />
                    </ScrollContainer>
                </div>
            </div>

      <div className="row adPanel px-2">
        <div className="col col-md-12">
          <AdvertisementPanel
          title="Conheça nossas soluções"
          description="Tecnologia e inovação para transformar seus negócios."
          image="https://terradata.com.br/img/logo.png"
          link="https://www.terradata.com.br"
          height={100}
        />
        </div>
      </div>
        </>}
    </>

}

export default ProfilePage;